export const otherLiabilityItems = [
  {
    displayValue: "Credit cards",
    value: "credit_cards"
  },
  {
    displayValue: "Overdrafts",
    value: "overdrafts"
  },
  {
    displayValue: "Loans from your business/trust",
    value: "business_or_trust_loans"
  },
  {
    displayValue: "Personal loan",
    value: "personal_loan"
  },
  {
    displayValue: "Loan from someone else",
    value: "loan_from_someone_else"
  },
  {
    displayValue: "Maintenance",
    value: "maintenance"
  },
  {
    displayValue: "Court order (including divorce)",
    value: "court_order"
  },
  {
    displayValue: "Did you sign surety for anyone?",
    value: "surety_signed"
  }
];



// WEBPACK FOOTER //
// ./src/views/Fna/steps/objects/otherLiabilityItems.js